import { LineChartDataItem } from '@views/pages/Dashboard/components';

export const useLineChart = ({
  chartData,
}: {
  chartData: LineChartDataItem[];
}) => {
  const xAxisValues = chartData.map(d => d.label);

  return {
    xAxisValues,
  };
};
